var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"input",attrs:{"value":_vm.value,"maxlength":"18"},on:{"input":_vm.onInput,"focus":_vm.onFocus}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }